import { Link } from 'react-router-dom';

const avatarBgColors = [
  'bg-primary-200',
  'bg-primary-300',
  'bg-primary-400',
  'bg-primary-500',
];

export default function AboutPreviewSection() {
  return (
    <section className="py-14 md:py-20 bg-primary-50/30">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-7xl">
          <div className="flex flex-col lg:flex-row items-start gap-10 md:gap-16">
            <div className="lg:w-1/3">
              <span className="text-foreground-400 text-xs font-medium tracking-widest uppercase">
                / 关于我们
              </span>
            </div>

            <div className="lg:w-2/3">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
                打造最优质的韩漫阅读体验，
                <br />
                让每一位读者都能找到心仪的作品
              </h2>

              <p className="text-foreground-600 text-base leading-relaxed mb-8 max-w-2xl">
                韩漫漫画诞生于对韩国漫画的热爱。我们致力于为中文读者提供一个纯净、免费、资源丰富的在线漫画平台。从选品到翻译，从界面设计到用户体验，每一个环节都倾注了我们的心血。我们相信，好的漫画值得被更多人看到。
              </p>

              <div className="flex flex-wrap items-center gap-6 mb-8">
                <div className="flex -space-x-3">
                  {[0, 1, 2, 3].map((i) => (
                    <div
                      key={i}
                      className={`w-10 h-10 rounded-full border-2 border-background-50 ${avatarBgColors[i]} flex items-center justify-center`}
                    >
                      <i className="ri-user-line text-primary-700 text-xs"></i>
                    </div>
                  ))}
                </div>
                <span className="text-foreground-500 text-sm">
                  已有 <strong className="text-foreground-950">超过200万</strong> 用户加入我们
                </span>
              </div>

              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 hover:bg-foreground-800 text-background-50 font-medium text-sm rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}